import Participant from "./Participant";

export default function Participants({
  errors,
  participants,
  register,
  handleRemoveParticipant,
}) {
  function handleRemove(id) {
    handleRemoveParticipant(id);
  }

  return (
    <>
      {participants &&
        participants.map((participant, index) => {
          return (
            <Participant
              key={index}
              errors={errors}
              register={register}
              id={index + 1}
              participantsLength={participants.length}
              handleRemove={handleRemove}
            />
          );
        })}
    </>
  );
}
